// extracted by mini-css-extract-plugin
module.exports = {"newPackageModal":"styles_newPackageModal__28buD","buttonContainer":"styles_buttonContainer__2u_Do"};